import React from 'react'
import { useStore } from '../../../../../../../hooks/useStore';


const MapVideoPlayButton = () => {
    const {uiStore: {showMapVideo}, cursorStore: {handleMouseEnter, handleMouseLeave}} = useStore();
    return (
        <svg 
            viewBox="0 0 58 58" 
            onClick={showMapVideo}
            onMouseEnter={() => handleMouseEnter("action", "Play Video")}
            onMouseLeave={handleMouseLeave}
        >
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Being-Copy-71" transform="translate(-1416.000000, -1541.000000)">
                    <g id="Group-3-Copy-9" transform="translate(1416.000000, 1541.000000)">
                        <circle id="Oval" fill="#FFFFFF" cx="29" cy="29" r="29"></circle>
                        <path d="M35.5151069,20.7487272 L37.6776877,40.0406987 C37.8622608,41.6872401 36.6771013,43.1716518 35.0305599,43.3562249 C34.808456,43.3811222 34.5842654,43.3811222 34.3621615,43.3562249 L15.0701901,41.193644 C13.4236486,41.0090709 12.2384891,39.5246593 12.4230622,37.8781178 C12.4988376,37.2021396 12.8020863,36.5719792 13.2830689,36.0909966 L30.4124595,18.961606 C31.5840324,17.7900332 33.4835273,17.7900332 34.6551002,18.961606 C35.1360827,19.4425886 35.4393314,20.072749 35.5151069,20.7487272 Z" id="Rectangle-Copy-10" fill="#000000" transform="translate(23.485585, 29.164122) rotate(-45.000000) translate(-23.485585, -29.164122) "></path>
                    </g>
                </g>
            </g>

            <style jsx>{`
                svg {
                    width: 30px;
                    cursor: pointer;
                }

                circle, path {
                    transition: color .2s ease;
                }
                svg:hover circle{
                    fill: black;
                }

                svg:hover path{
                    fill: white;
                }

            `}</style>
        </svg>
    );
}

export default MapVideoPlayButton